module.exports = "/packs/media/modules/welcome/welcome/faq/assets/StartHubGuideEn-68b331935e6b12221e30452cd549455c.pdf";